import { useApprovalCentre } from '@/hooks/useApprovalCentre'
import { useAppStore } from '@/store'

export function ApprovalIndicator() {
  const { pendingCount, pollError } = useApprovalCentre()
  const setActiveSection = useAppStore(s => s.setActiveSection)

  function openApprovalCentre() {
    setActiveSection('governance')
    window.setTimeout(() => document.getElementById('approval-centre')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50)
  }

  return (
    <button
      onClick={openApprovalCentre}
      aria-label={pendingCount > 0 ? `Approval Centre — ${pendingCount} pending approvals` : 'Approval Centre — no pending approvals'}
      className="ops-approval-object-hitbox relative flex items-center justify-center"
      title={pollError ? `Approval poll error: ${pollError}` : pendingCount > 0 ? `${pendingCount} pending approval${pendingCount !== 1 ? 's' : ''}` : 'Approval Centre'}
    >
      <svg className="ops-approval-shield-svg" viewBox="0 0 48 52" aria-hidden="true">
        <defs>
          <linearGradient id="opsShieldFace" x1="9" y1="4" x2="39" y2="47" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#efe7ff" />
            <stop offset=".22" stopColor="#b89cff" />
            <stop offset=".5" stopColor="#7957dc" />
            <stop offset=".78" stopColor="#3f2f8c" />
            <stop offset="1" stopColor="#1f184f" />
          </linearGradient>
          <linearGradient id="opsShieldInner" x1="14" y1="10" x2="33" y2="41" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#72d9ff" />
            <stop offset=".28" stopColor="#4d8dff" />
            <stop offset=".65" stopColor="#5947d4" />
            <stop offset="1" stopColor="#221d65" />
          </linearGradient>
          <linearGradient id="opsShieldEdge" x1="7" y1="5" x2="42" y2="45" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#ffffff" stopOpacity=".92" />
            <stop offset=".25" stopColor="#b8a8ff" stopOpacity=".88" />
            <stop offset=".65" stopColor="#5f56d8" stopOpacity=".85" />
            <stop offset="1" stopColor="#181139" stopOpacity=".95" />
          </linearGradient>
          <filter id="opsShieldShadow" x="-40%" y="-35%" width="180%" height="190%">
            <feDropShadow dx="0" dy="3" stdDeviation="2.3" floodColor="#160f45" floodOpacity=".72" />
            <feDropShadow dx="0" dy="0" stdDeviation="2.2" floodColor="#785cff" floodOpacity=".34" />
          </filter>
        </defs>
        <g filter="url(#opsShieldShadow)">
          <path d="M24 3.5 40.5 9v14.2c0 10.8-6.4 19.6-16.5 25.3C13.9 42.8 7.5 34 7.5 23.2V9L24 3.5Z" fill="url(#opsShieldFace)" stroke="url(#opsShieldEdge)" strokeWidth="1.5"/>
          <path d="M24 8.4 35.8 12.3v10.4c0 8.2-4.6 15-11.8 19.5-7.2-4.5-11.8-11.3-11.8-19.5V12.3L24 8.4Z" fill="url(#opsShieldInner)" stroke="#d8ceff" strokeOpacity=".8" strokeWidth="1"/>
          <path d="M17.8 24.3 22 28.5l8.5-9" fill="none" stroke="#f3eeff" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M11.4 12.1 24 7.8 36.5 12" fill="none" stroke="#ffffff" strokeOpacity=".62" strokeWidth="1.2" strokeLinecap="round"/>
          <path d="M13.4 32.6c2.4 4 5.9 7.3 10.6 10.1" fill="none" stroke="#77dfff" strokeOpacity=".45" strokeWidth="1.2" strokeLinecap="round"/>
        </g>
      </svg>
      {pendingCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-0.5 rounded-full bg-accent flex items-center justify-center text-[10px] font-bold text-white leading-none animate-pulse shadow-[0_2px_8px_rgba(67,97,255,.45)]">
          {pendingCount > 9 ? '9+' : pendingCount}
        </span>
      )}
      {pollError && pendingCount === 0 && <span className="absolute top-0 right-0 h-2.5 w-2.5 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,.65)]" />}
    </button>
  )
}
